import { DndContext, type DragEndEvent, MouseSensor, TouchSensor, type UniqueIdentifier, useSensor } from '@dnd-kit/core';
import { restrictToVerticalAxis } from '@dnd-kit/modifiers';
import { SortableContext } from '@dnd-kit/sortable';
export const SortableContainer = ({
  onDragEnd,
  items,
  children,
  /**
   * 내부 래퍼의 태그. 기본은 div 다.
   * 순서 맞추기는 `<ol>` 안에 `<li>` 를 직접 넣어야 목록 시맨틱이 유지되므로
   * 'ol' 을 넘겨 래퍼 자체를 목록으로 만든다.
   */
  as: Wrapper = 'div'
}: {
  onDragEnd: (event: DragEndEvent) => void;
  items: UniqueIdentifier[];
  children: React.ReactNode;
  as?: 'div' | 'ol' | 'ul';
}) => {
  const mouseSensor = useSensor(MouseSensor, {
    activationConstraint: {
      // 상하 50px 이상 드래그 시 활성화
      distance: {
        x: 0,
        y: 50
      }
    }
  });
  const touchSensor = useSensor(TouchSensor, {
    activationConstraint: {
      delay: 100,
      tolerance: 10
    }
  });
  return <DndContext sensors={[mouseSensor, touchSensor]} modifiers={[restrictToVerticalAxis]} onDragEnd={onDragEnd} data-sentry-element="DndContext" data-sentry-component="SortableContainer" data-sentry-source-file="SortableContainer.tsx">
      <SortableContext items={items} data-sentry-element="SortableContext" data-sentry-source-file="SortableContainer.tsx">
        <Wrapper className="relative flex flex-col gap-2xs" data-sentry-element="Wrapper" data-sentry-source-file="SortableContainer.tsx">{children}</Wrapper>
      </SortableContext>
    </DndContext>;
};